/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Link_Os_UiInputs */

const en_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS UI`)
};

const ar_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة نظام التشغيل`)
};

const bn_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS UI`)
};

const de_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betriebssystem-Benutzeroberfläche`)
};

const es_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interfaz de usuario del sistema operativo`)
};

const fr_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`interface utilisateur du système d'exploitation`)
};

const pt_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IU do SO`)
};

const zh_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作系统用户界面`)
};

const tr_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşletim Sistemi Kullanıcı Arayüzü`)
};

const ru_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательский интерфейс ОС`)
};

const pl_quick_link_os_ui = /** @type {(inputs: Quick_Link_Os_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interfejs systemu operacyjnego`)
};

/**
* | output |
* | --- |
* | "OS UI" |
*
* @param {Quick_Link_Os_UiInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const quick_link_os_ui = /** @type {((inputs?: Quick_Link_Os_UiInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Link_Os_UiInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_quick_link_os_ui(inputs)
	if (locale === "bn") return bn_quick_link_os_ui(inputs)
	if (locale === "de") return de_quick_link_os_ui(inputs)
	if (locale === "es") return es_quick_link_os_ui(inputs)
	if (locale === "fr") return fr_quick_link_os_ui(inputs)
	if (locale === "pt") return pt_quick_link_os_ui(inputs)
	if (locale === "zh") return zh_quick_link_os_ui(inputs)
	if (locale === "tr") return tr_quick_link_os_ui(inputs)
	if (locale === "ru") return ru_quick_link_os_ui(inputs)
	if (locale === "pl") return pl_quick_link_os_ui(inputs)
	return en_quick_link_os_ui(inputs)
});